import { CustomEventTypes } from '../globals';

let FPS = 0;
let deltaTime = 0;
let initialized = false;
let prevTime = 0;
let prevFPSTime = 0;
let frames = 0;

export default class Time
{
	static init = () =>
	{
		if (!initialized)
		{
			initialized = true;
			prevTime = ( performance || Date ).now();
			prevFPSTime = prevTime;
		}
	}

	static getFPS = () =>
	{
		return FPS;
	}

	static getDeltaTime = () =>
	{
		return deltaTime;
	}

	static update = () =>
	{
		const currentTime = ( performance || Date ).now();
		frames ++;
		if ( currentTime >= prevFPSTime + 1000 )
		{
			const newFPS = Math.round(( frames * 1000 ) / ( currentTime - prevFPSTime ));
			prevFPSTime = currentTime;
			frames = 0;
			if (newFPS !== FPS) document.dispatchEvent(new CustomEvent(CustomEventTypes.FPSUpdated, { detail: { fps: FPS } }));
			FPS = newFPS;
		}

		deltaTime = (currentTime - prevTime) / 1000;
		prevTime = currentTime;
	}
}
